/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyUserNotification
 */
export interface CompanyUserNotification {
    /**
     * 
     * @type {number}
     * @memberof CompanyUserNotification
     */
    notificationId: number;
    /**
     * 通知情報の内容
     * @type {string}
     * @memberof CompanyUserNotification
     */
    text: string;
    /**
     * 通知情報のurl
     * @type {string}
     * @memberof CompanyUserNotification
     */
    url: string;
    /**
     * 通知情報の登録日 YYYY/mm/dd形式
     * @type {string}
     * @memberof CompanyUserNotification
     */
    date: string;
    /**
     * 既読済みか
     * @type {boolean}
     * @memberof CompanyUserNotification
     */
    isMarkAsRead: boolean;
}

/**
 * Check if a given object implements the CompanyUserNotification interface.
 */
export function instanceOfCompanyUserNotification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notificationId" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "isMarkAsRead" in value;

    return isInstance;
}

export function CompanyUserNotificationFromJSON(json: any): CompanyUserNotification {
    return CompanyUserNotificationFromJSONTyped(json, false);
}

export function CompanyUserNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUserNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notificationId': json['notification_id'],
        'text': json['text'],
        'url': json['url'],
        'date': json['date'],
        'isMarkAsRead': json['is_mark_as_read'],
    };
}

export function CompanyUserNotificationToJSON(value?: CompanyUserNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notification_id': value.notificationId,
        'text': value.text,
        'url': value.url,
        'date': value.date,
        'is_mark_as_read': value.isMarkAsRead,
    };
}

